import React from 'react';
import useAuth from '../hooks/useAuth.ts';
import UnauthorizedAccess from './UnauthorizedAccess.tsx';

interface ProtectedRouteProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
  const { auth } = useAuth();
  
  // Check if user has one of the allowed roles
  const hasAccess = auth.user && allowedRoles.includes(auth.user.role);
  
  return hasAccess ? <>{children}</> : <UnauthorizedAccess />;
};

export default ProtectedRoute;
